import { formatDuration } from "./utils/formatters";

export class TimerState {
  #durationInterval = null;
  callDuration = $state(0);
  initialDuration = $state(0);
  formattedDuration = $derived(formatDuration(this.callDuration));

  constructor() {
    this.#durationInterval = null;
  }

  startDurationTimer() {
    this.callDuration = parseInt(this.initialDuration);
    this.#durationInterval = setInterval(() => {
      this.callDuration++;
    }, 1000);
  }

  stopDurationTimer() {
    clearInterval(this.#durationInterval);
    this.#durationInterval = null;
    this.callDuration = 0;
  }
}
